import {
  BooleanResponseResult,
  ConnectDeviceCommand,
  DeviceLineWithDocumentViewModel,
  InventoryProxy,
  SearchDeviceQueryResponse,
  SearchDeviceQueryResponseResponseResult,
} from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SelectPlantsModalComponent } from '../../../account/devices/select-plants-modal/select-plants-modal.component';

@Component({
  selector: 'widget-no-device',
  imports: [SharedModule, SelectPlantsModalComponent],
  providers: [InventoryProxy],
  templateUrl: './widget-no-device.component.html',
  styleUrl: './widget-no-device.component.less',
})
export class WidgetNoDeviceComponent {
  @ViewChild('selectPlantationModal') selectPlantationModal!: SelectPlantsModalComponent;
  foundDevice: SearchDeviceQueryResponse | undefined = undefined;
  selectedDevice: DeviceLineWithDocumentViewModel | undefined = undefined;
  backendErrorMessage: string | undefined = undefined;
  addDeviceSearchQuery = '';
  searchingDevice: boolean = false;

  @Output() triggerRetry = new EventEmitter<Event>();
  @Output() requestCallbackEvent = new EventEmitter<void>();

  constructor(private _inventoryProxy: InventoryProxy) {}

  searchDevice() {
    this.searchingDevice = true;
    this._inventoryProxy
      .inventory_SearchDevice(this.addDeviceSearchQuery)
      .subscribe((res: SearchDeviceQueryResponseResponseResult) => {
        if (res.isSuccess) {
          this.foundDevice = res.result;
        } else {
          this.backendErrorMessage = res.errors[0].message.split(':')[1];
        }
        this.searchingDevice = false;
      });
  }

  confirmDevice() {
    // OPEN the plantation selection model
    if (this.foundDevice?.isPlantationBased) {
      this.openSelectPlantationModal();
    } else {
      this.onPlantationSelected([]);
    }
  }

  openSelectPlantationModal(): void {
    this.selectPlantationModal.show(this.foundDevice.assetId);
  }

  requestCallback() {
    this.requestCallbackEvent.emit();
  }

  onPlantationSelected(plantationIds: string[]): void {
    let input = new ConnectDeviceCommand();
    input.id = this.foundDevice.id;
    input.plantations = plantationIds;
    this._inventoryProxy.inventory_ConnectDevice(input).subscribe((res: BooleanResponseResult) => {
      if (res.isSuccess) {
        this.selectedDevice = undefined;
        this.foundDevice = undefined;
        this.backendErrorMessage = undefined;
      } else {
        this.backendErrorMessage = res.errors[0].message.split(':')[1];
      }
    });
  }
}
